import type * as lazyIndex from './lazyIndex';
import MessageAdListPreloadingStubElement from './components/MessageAdListPreloadingStubElement';
import { logUsage } from 'owa-analytics';
import { createLazyComponent, type LazyComponent, LazyModule } from 'owa-bundling';
import { getAdMarketPublishGroupCode } from 'owa-mail-ads-shared';
import { getGlobalSettingsAccountMailboxInfo } from 'owa-account-source-list-store';
import type { MessageAdListProps } from './components/MessageAdList';
const messageAdListLazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "MessageAdList" */ './lazyIndex'),
    { name: 'MessageAdList' }
);

// Delay loaded components
export const MessageAdList: LazyComponent<MessageAdListProps, unknown, void> = createLazyComponent(
    messageAdListLazyModule,
    m => m.MessageAdList,
    () => <MessageAdListPreloadingStubElement />,
    () => {
        // Log the information so that we know how much is adblocker blocks native ads
        const adMarket = getAdMarketPublishGroupCode();

        logUsage('ShowNativeAd', getGlobalSettingsAccountMailboxInfo(), {
            actualShow: false,
            adMarket,
            actualNoShowReason: 'adblocker',
            OtherPivot: true,
        });
    }
);
